import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { Snowflake, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-[calc(100vh-200px)] grid place-items-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl bg-ink-800 ring-1 ring-white/10 p-8">
        <div className="flex items-center gap-2.5">
          <div className="size-10 rounded-xl bg-ice-400/15 grid place-items-center ring-1 ring-ice-400/40"><Snowflake className="size-5 text-ice-400"/></div>
          <div><div className="font-display font-black">AIR-COLD HVAC</div><div className="text-[10px] uppercase tracking-[0.25em] text-silver-400">Admin</div></div>
        </div>
        <h1 className="mt-6 font-display text-2xl font-black">Sign In</h1>
        <p className="mt-1 text-sm text-silver-400">Manage reviews, projects, pricing, and submissions.</p>
        <div className="mt-6 grid gap-3">
          <input type="email" required placeholder="Email" className="input" value={email} onChange={e=>setEmail(e.target.value)} data-testid="login-email"/>
          <input type="password" required placeholder="Password" className="input" value={password} onChange={e=>setPassword(e.target.value)} data-testid="login-password"/>
        </div>
        {err && <div className="mt-3 text-sm text-red-400" data-testid="login-error">{err}</div>}
        <button disabled={loading} className="mt-5 btn-primary rounded-full px-5 py-3 text-sm w-full flex items-center justify-center gap-2" data-testid="login-submit">
          <LogIn className="size-4"/> {loading?"Signing in...":"Sign In"}
        </button>
      </form>
      <style>{`.input{background:#1C274C;border-radius:.75rem;padding:.75rem 1rem;font-size:.875rem;outline:none;width:100%;border:1px solid rgba(255,255,255,0.08);color:white;}
      .input:focus{border-color:#00A8E8;box-shadow:0 0 0 3px rgba(0,168,232,0.18);}`}</style>
    </main>
  );
}
